export {default as blob} from "./blob.js";
export {default as buffer} from "./buffer.js";
export {default as dsv, csv, tsv} from "./dsv.js";
export {default as image} from "./image.js";
export {default as json} from "./json.js";
export {default as text} from "./text.js";
export {default as xml, html, svg} from "./xml.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-fetch/src/index.js
// module id = ./node_modules/d3-fetch/src/index.js
// module chunks = 54